export * from './modal-popup.component';
